import * as React from 'react';

import HeadSeo from 'components/Layout/HeadSeo';

type Props = {
  data: any;
  children?: React.ReactNode;
};

const GetSeo = ({ data, children }: Props) => (
  <>
    <HeadSeo
      canonicalUrl={`${data?.canonicalUrl}`}
      description={data?.description}
      icon={data?.icon}
      ogImageUrl={data?.image}
      ogTwitterImage={data?.image}
      ogType="article"
      site={data?.site}
      siteName={data?.siteName}
      title={`${data?.title}`}
    >
      <script
        dangerouslySetInnerHTML={{
          __html: `
                {
                  "@context":"http://schema.org",
                  "@type":"Organization",
                  "name":"${data?.title}",
                  "url":"${data?.canonicalUrl}",
                  "image":"${data?.image}",
                  "aggregateRating":
                    {
                      "@type":"AggregateRating",
                      "bestRating":5,
                      "worstRating":1,
                      "ratingCount":"${data?.reviewCount}",
                      "ratingValue":"${data?.ratingValue}"
                    }
                  }
                `,
        }}
        type="application/ld+json"
      />
      <script
        dangerouslySetInnerHTML={{
          __html: `
                {
                  "@context":"https://schema.org",
                  "@type":"BreadcrumbList",
                  "itemListElement": [{
                    "@type": "ListItem",
                    "position": 1,
                    "name": "Trang chủ",
                    "item": "${data?.canonicalUrl}"
                  },
                  {
                    "@type": "ListItem",
                    "position": 2,
                    "name": "Giới thiệu",
                    "item": "${data?.canonicalUrl}/introduce"
                  },
                  {
                    "@type": "ListItem",
                    "position": 3,
                    "name": "Sản phẩm",
                    "item": "${data?.canonicalUrl}/products"
                  },
                  {
                    "@type": "ListItem",
                    "position": 4,
                    "name": "Chuỗi cửa hàng",
                    "item": "${data?.canonicalUrl}/branch"
                  },
                  {
                    "@type": "ListItem",
                    "position": 5,
                    "name": "Cộng tác viên",
                    "item": "${data?.canonicalUrl}/collaborator"
                  }
                ]
                }`,
        }}
        type="application/ld+json"
      />
      <script
        dangerouslySetInnerHTML={{
          __html: `
                {
                  "@context": "https://schema.org",
                  "@type": "WebSite",
                  "url": "${data?.canonicalUrl}",
                  "potentialAction": {
                    "@type": "SearchAction",
                    "target": "${data?.canonicalUrl}/search/?q={search_term_string}",
                    "query-input": "required name=search_term_string"
                  }
                }`,
        }}
        type="application/ld+json"
      />
    </HeadSeo>
    {children}
  </>
);

export default GetSeo;
